import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import { PhFilePdf, PhWarning } from 'ember-phosphor-icons';
import type { TOC } from '@ember/component/template-only';

interface NotValidatedBannerSignature {
  Args: {
    filename: string;
    onUseAnyways: () => void;
    onDiscard: () => void;
  };
  Element: HTMLDivElement;
}

/**
 * Amber "was flagged" alert shown when AI processing finished but could not
 * classify the document into any of the configured types (e.g.
 * detected_document_types is empty or only "general"). Mirrors the yellow
 * "Mini-Alert" rows in Figma (4449-2773, 4449-2871).
 *
 * The employee can `use anyways` (accept the unverified file) or `discard`.
 */
const NotValidatedBanner: TOC<NotValidatedBannerSignature> = <template>
  <div
    class="app-banner-strip app-banner-strip--warning"
    role="status"
    data-test-not-validated-banner
    ...attributes
  >
    <PhWarning @size="18" @weight="fill" class="mt-0.5 shrink-0 app-icon-warning" />
    <div class="flex min-w-0 flex-1 flex-wrap items-center gap-1.5 text-sm">
      <PhFilePdf @size="14" class="shrink-0" />
      <span class="truncate font-medium app-status-text-warning">{{@filename}}</span>
      <span>
        {{t "tas.attachments.not_validated_message"}}
      </span>
    </div>
    <div class="flex shrink-0 items-center gap-3 text-sm">
      <button
        type="button"
        class="font-semibold app-status-text-warning underline"
        data-test-not-validated-use-anyways
        {{on "click" @onUseAnyways}}
      >
        {{t "tas.attachments.use_anyways"}}
      </button>
      <span class="opacity-40">|</span>
      <button
        type="button"
        class="font-semibold app-status-text-warning underline"
        data-test-not-validated-discard
        {{on "click" @onDiscard}}
      >
        {{t "tas.attachments.discard"}}
      </button>
    </div>
  </div>
</template>;

export default NotValidatedBanner;
